/* eslint-disable */
import React, { useState, useEffect } from "react";
import { fetchUrl } from "../../config";

function InvoicePdf({ checkArrInv, edit }) {
  const orders = checkArrInv || [];
  const [phones, setPhones] = useState([]);

  useEffect(() => {
    fetch(`${fetchUrl}/api/phone/`)
      .then((res) => res.json())
      .then((datas) => setPhones(datas));
  }, []);

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const content = `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Invoices</title>
        <style>
          /* Strict Reset to prevent extra pages */
          * { 
            box-sizing: border-box; 
            margin: 0; 
            padding: 0;
            -webkit-print-color-adjust: exact; 
            print-color-adjust: exact; 
          }
          html, body {
            height: 100%;
            background: #ffffff; 
            color: #000000;
            font-family: 'Segoe UI', Arial, sans-serif; 
          }
          
          /* Print Settings */
          @media print {
            body { overflow: hidden; }
            @page { 
              size: A5 portrait; 
              margin: 0; 
            }
            .print-btn { 
              display: none !important; 
            }
            .page-container { 
              page-break-after: always; 
              page-break-inside: avoid;
              height: 100vh !important; 
              padding: 5mm !important;
            }
          }

          /* Page Framework - Dynamic 3-row grid layout (1/3rd height each) */
          .page-container {
            width: 100%;
            max-width: 148mm; 
            height: 100vh;
            margin: 0 auto;
            background: #ffffff;
            padding: 5mm;
            display: grid;
            grid-template-rows: repeat(3, 1fr); 
            row-gap: 4mm; 
          }

          /* Invoice Row Structure */
          .invoice-row {
            border: 1px solid #d1d5db;
            border-radius: 4px;
            padding: 10px 14px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            background: #ffffff;
            overflow: hidden;
          }

          /* Centered Shop Header Block */
          .shop-header-block {
            text-align: center;
            border-bottom: 1px solid #e5e7eb;
            padding-bottom: 4px;
            margin-bottom: 4px;
          }
          .shop-title { font-size: 18px; font-weight: bold; margin: 0; letter-spacing: 0.5px; }
          .shop-hotline { font-size: 11px; margin: 2px 0 0 0; font-weight: normal; color: #4b5563; }

          /* Meta Row */
          .meta-row {
            display: flex;
            justify-content: space-between;
            font-size: 11px;
            padding-bottom: 6px;
            margin-bottom: 8px;
          }
          .order-id { font-weight: bold; }

          /* Content Core Area Split */
          .invoice-body {
            display: flex;
            justify-content: space-between;
            gap: 16px;
            flex-grow: 1;
          }
          
          .customer-side { width: 55%; font-size: 11px; line-height: 1.4; }
          .customer-name { font-size: 13px; margin-bottom: 4px; }
          
          /* Target highlighted phone styling for courier entry */
          .customer-phone-highlight { 
            font-size: 15px; 
            font-weight: 800; 
            margin: 4px 0;
            letter-spacing: 0.3px;
          }
          
          .product-side { width: 42%; text-align: right; display: flex; flex-direction: column; justify-content: space-between; }
          .product-info { font-size: 11px; line-height: 1.4; }
          .product-meta { font-size: 10px; margin-top: 2px; color: #4b5563; }
          
          /* Clean & Subtle Total Box */
          .price-box {
            border: 1px solid #d1d5db;
            border-radius: 4px;
            padding: 4px 10px;
            font-size: 13px;
            font-weight: bold;
            display: inline-block;
            align-self: flex-end;
          }

          /* Invoice Footer / Bottom Elements Area */
          .invoice-footer-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: auto;
            padding-top: 4px;
          }

          /* Note styling at bottom left */
          .order-note-box {
            font-size: 10px;
            color: #374151;
            max-width: 55%;
            word-wrap: break-word;
            line-height: 1.3;
            font-style: italic;
          }

          .print-btn {
            display: block; margin: 20px auto; padding: 10px 20px;
            font-size: 14px; font-weight: bold; background: #000000;
            color: #ffffff; border: 1px solid #000000; cursor: pointer;
            border-radius: 4px;
          }
        </style>
      </head>
      <body>
        <button class="print-btn" onclick="window.print()">Print Invoices</button>
        
        ${(() => {
          let chunks = [];
          for (let i = 0; i < orders.length; i += 3) {
            chunks.push(orders.slice(i, i + 3));
          }

          const formatInvoiceDate = () => {
            const dateObj = new Date();
            const day = dateObj.getDate();
            const month = dateObj.toLocaleString("en-US", { month: "short" });
            const year = dateObj.getFullYear();
            return day + " " + month + ", " + year;
          };

          return chunks
            .map(
              (pageOrders) => `
            <div class="page-container">
              ${pageOrders
                .map(
                  (order) => `
                <div class="invoice-row">
                  
                  <div class="shop-header-block">
                    <h1 class="shop-title">Bachaai-বাছাই</h1>
                    <p class="shop-hotline">Hatirpool, Shahbag, Dhaka. Hotline: ${
                      phones[0]?.phone || "Phone"
                    }</p>
                  </div>

                  <div class="meta-row">
                    <div class="order-id">Order ID: ${
                      order.order_id || "N/A"
                    }</div>
                    <div><strong>Date:</strong> ${formatInvoiceDate(
                      order.order_at,
                    )}</div>
                  </div>
                  
                  <div class="invoice-body">
                    <div class="customer-side">
                      <div class="customer-name"><strong>Name:</strong> ${
                        order.name || "Customer"
                      }</div>
                      
                      <div class="customer-phone-highlight">
                        <strong>Phone:</strong> ${order.phone || "N/A"}
                      </div>
                      
                      <div style="margin-top: 4px;">
                        <strong>Address:</strong> ${order.address || "N/A"}
                      </div>
                    </div>
                    
                    <div class="product-side">
                      <div class="product-info">
                        <div><strong>${order.products || "Items"}</strong></div>
                        <div class="product-meta">
                          ${[
                            order.color ? `Color: ${order.color}` : "",
                            order.size ? `Size: ${order.size}` : "",
                            order.quantity ? `Qty: ${order.quantity}` : "",
                          ]
                            .filter(Boolean)
                            .join(" | ")}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="invoice-footer-row">
                    <div class="order-note-box">
                      ${
                        order.note ? `<strong>Note:</strong> ${order.note}` : ""
                      }
                    </div>
                    <div class="price-box">
                      Total: ৳${order.total_amount || 0}
                    </div>
                  </div>

                </div>
              `,
                )
                .join("")}
            </div>
          `,
            )
            .join("");
        })()}

        <script>
          window.onload = function() {
            setTimeout(() => { window.print(); }, 500);
          }
        </script>
      </body>
    </html>
    `;

    printWindow.document.write(content);
    printWindow.document.close();
  };

  return (
    edit && (
      <button onClick={handlePrint} type="button" className="btn btn-primary">
        Print Invoices ({orders.length})
      </button>
    )
  );
}

export default InvoicePdf;
